import React, { useMemo, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useHistory, useLocation } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import { inject, observer } from "mobx-react";

import CommonButton from "@/views/CommonComponent/CommonButton";
import TitleBox from "../CommonComponent/TitleBox";
import { FormCard, HelperText, ErrorText } from "./Styled/PenNameEditStyled";
import {PlainInputField} from "@/views/SignIn/Styled/SignInStyled";

function PenNameEdit(props) {
  const { intl, authStore, userStore } = props;
  const history = useHistory();
  const location = useLocation();

  const deviceId = location.state?.deviceId || null;
  const initialPenName = location.state?.penName || "";
  useEffect(() => {
      authStore.setPenName(initialPenName);
  }, []);

  const [touched, setTouched] = useState(false);

  const penNameValidationMessage = authStore.isNotAcceptablePenName(intl, authStore.penName);
  const showPenNameError = (authStore.penName || "").trim() !== "" && penNameValidationMessage !== "";

  const isSaveDisabled = useMemo(() => {
    const value = (authStore.penName || "").trim();
    return value.length === 0 || showPenNameError;
  }, [initialPenName, authStore.penName, showPenNameError]);

  const handleBack = () => history.goBack();

  const handleChange = (event) => {
    const value = event.target.value;
    setTouched(true);
    authStore.setPenName(value);
  };

  const handleBlur = () => setTouched(true);

  // const handleKeyDown = (event) => {
  //   if (event.key === "Backspace") {
  //     event.preventDefault();
  //     setTouched(true);
  //     authStore.setPenName("");
  //   }
  // };

  const handleSave = () => {
    userStore.updatePenName(authStore.loginUser.id, deviceId, authStore.penName, () => {
      authStore.setPenName("");
      history.push("/deviceDetail", { deviceId, from: location.state?.from })
    });
  };

  if (!location.state || !deviceId) {
    history.replace("/deviceList");
    return null;
  }

  return (
    <>
      <Stack width="100%" height="100vh">
        <TitleBox
          title={intl.formatMessage({ id: "pen_name_edit_title" })}
          subtitle={intl.formatMessage({ id: "pen_name_edit_subtitle" })}
          onBack={handleBack}
        />

        <Stack p={3} pt={4} flex={1} justifyContent="space-between">
          <FormCard>
            <PlainInputField
              fullWidth
              value={authStore.penName}
              onChange={handleChange}
              onBlur={handleBlur}
              // onKeyDown={handleKeyDown}
              placeholder={intl.formatMessage({ id: "pen_name_placeholder" })}
              autoComplete="off"
              inputProps={{ maxLength: 16, "aria-label": "pen-name" }}
            />
            {touched && showPenNameError ? (
              <ErrorText>{penNameValidationMessage}</ErrorText>
            ) : (
              <HelperText>{intl.formatMessage({ id: "pen_name_helper" })}</HelperText>
            )}
          </FormCard>

          <Box width="100%" mt="auto">
            <CommonButton
              text={intl.formatMessage({ id: "dialog_save" })}
              background="#FDD751"
              color="#333"
              disabled={isSaveDisabled}
              onClick={handleSave}
            />
          </Box>
        </Stack>
      </Stack>
    </>
  );
}

export default injectIntl(inject("authStore", "userStore")(observer(PenNameEdit)));

